import { paymentStatementApi } from "./base";

export type MerchantRecordStatus =
	"processing" | "completed" | "partial" | "failed";

export interface MerchantRecordMonth {
	file_id: string;
	filename: string;
	statement_month: string | null;
	uploaded_at: string | null;
	status: string;
	needs_review: boolean;
	blocks_quote: boolean;
	duplicate_month: boolean;
	averaged: boolean;
	detected_rate_plan_type: string | null;
}

export interface MerchantRecordLine {
	key: string;
	description: string | null;
	section: string;
	card_type: string | null;
	is_root: boolean;
	months_present: number;
	volume: number;
	transactions: number;
	current_fee: number;
	proposed_fee: number;
}

export interface MerchantRecordAnalysis {
	months_averaged: number;
	lines: MerchantRecordLine[];
	totals: {
		volume: number;
		transactions: number;
		batches: number;
		current_fees: number;
		proposed_fees: number;
		savings: number;
		yearly_savings: number;
	};
}

export interface MerchantRecord {
	id: string;
	merchant_name: string;
	status: MerchantRecordStatus;
	mixed_rate_plan_types: boolean;
	months: MerchantRecordMonth[];
	analysis: MerchantRecordAnalysis | null;
}

export const merchantRecordsApi = paymentStatementApi.injectEndpoints({
	endpoints: (builder) => ({
		createMerchantRecord: builder.mutation<
			{ id: string; merchant_name: string; max_months: number },
			{ merchant_name: string }
		>({
			query: (body) => ({
				url: "/statement/merchant-records",
				method: "POST",
				body,
			}),
		}),
		getMerchantRecord: builder.query<MerchantRecord, string>({
			query: (recordId) => `/statement/merchant-records/${recordId}`,
		}),
		// Only a record with no months; months are deleted as statements.
		deleteEmptyMerchantRecord: builder.mutation<void, string>({
			query: (recordId) => ({
				url: `/statement/merchant-records/${recordId}`,
				method: "DELETE",
			}),
		}),
	}),
});

export const {
	useCreateMerchantRecordMutation,
	useDeleteEmptyMerchantRecordMutation,
	useGetMerchantRecordQuery,
	useLazyGetMerchantRecordQuery,
} = merchantRecordsApi;
